import React from "react";
import { CommunicationHistoryContainer } from "../../../containers";
import { withAppLayout } from "../../../hoc";

const CommunicationHistory = (props) => {
  return <CommunicationHistoryContainer {...props} />;
};

export default CommunicationHistory;
